import { useUser } from '@/hooks/useUser';

export const withUser = (Component) => (props) => {
	const userData = useUser();

	return <Component {...props} {...userData} />;
};
